import CheckingLocationPopupWithMap from './WithMap'
import CheckingLocationPopupBasic from './Basic'
import type { LatLngLiteral } from 'leaflet'
import { useReduxSelector } from 'store'
import { selectConfig } from 'appSlice'
import React from 'react'
import './style.scss'

export type Status = 'idle' | 'pending-succeed' | 'pending-failed' | 'succeed' | 'failed'
interface CheckingLocationPopupProps {
  type?: 'map' | 'basic'
  targetPosition?: LatLngLiteral
  callback: (success: boolean) => void
}

export interface CheckingLocationPopupChildProps extends CheckingLocationPopupProps {
  distanceAccuracy: number
}

const DISTANCE_ACCURACY = 50 // meters
const CheckingLocationPopup: React.FC<CheckingLocationPopupProps> = (props) => {
  const config = useReduxSelector(selectConfig)
  const distanceAccuracy = config?.distanceAccuracy || DISTANCE_ACCURACY
  if (props.type === 'map') return (
    <CheckingLocationPopupWithMap
      distanceAccuracy={distanceAccuracy}
      {...props}
    />
  )

  return (
    <CheckingLocationPopupBasic
      distanceAccuracy={distanceAccuracy}
      {...props}
    />
  )
}


export default CheckingLocationPopup